/**
 * ลิงก์สมัครสมาชิก "สมัครครอบครัวศรีคเนศ" = หน้าสมาชิกเดิม + join=1 (การ์ดชวนสมัครใน LINE · CF chat/membership.js memberJoinLiffUrl)
 * - เปิดในแอป LINE: ผูกบัญชีเอง → ฟอร์มยืนยันข้อมูลเปิดเอง (โปรไฟล์ยังไม่ครบ) หัวข้อเป็นการสมัคร
 * - เปิดนอก LINE: หน้าแรกคง join=1 ไว้ → ปุ่มเข้าสู่ระบบพากลับมาพร้อม join=1
 * - สมัครสำเร็จครั้งแรก memberApi คืน welcome → พิธีต้อนรับ (ครั้งเดียว — server จำ welcomeShownAt)
 */

export type WelcomeTier = { id: string; name: string; icon?: string; color?: string }
export type MemberWelcome = {
  first: boolean
  displayName?: string
  lifetimeTotal?: number
  membership?: { tier: WelcomeTier; points?: number; nextTier?: WelcomeTier | null; toNextTierBaht?: number }
}

/** อ่าน join=1 จาก query (รวมกรณี LIFF ห่อไว้ใน liff.state) */
/** ค่า ?open= (รวมกรณี LIFF ห่อไว้ใน liff.state) — address = แผงข้อมูลพื้นฐาน · backup = ที่อยู่สำรอง */
export function readOpenIntent(search: string): string {
  const params = new URLSearchParams(search || '')
  const direct = params.get('open')
  if (direct) return direct
  const state = params.get('liff.state')
  if (!state) return ''
  const q = state.includes('?') ? state.slice(state.indexOf('?')) : state
  return new URLSearchParams(q).get('open') || ''
}

/** ลิงก์จากการ์ด "ที่อยู่จัดส่ง" ใน LINE (?open=address) → เปิดแผงข้อมูลพื้นฐาน/ที่อยู่ทันที */
export function readOpenAddressIntent(search: string): boolean {
  return readOpenIntent(search) === 'address'
}

export function readJoinIntent(search: string): boolean {
  const params = new URLSearchParams(search || '')
  if (params.get('join') === '1') return true
  const state = params.get('liff.state')
  if (!state) return false
  const q = state.includes('?') ? state.slice(state.indexOf('?')) : state
  return new URLSearchParams(q).get('join') === '1'
}

/** ตัด join=1 ออกจาก URL หลังสมัครสำเร็จ (รีโหลดแล้วไม่เป็นหน้าสมัครอีก) */
export function stripJoinParam(href: string): string {
  const url = new URL(href)
  url.searchParams.delete('join')
  return url.pathname + url.search + url.hash
}

/** ข้อมูลที่แสดงในพิธีต้อนรับ — ไม่มีระดับ (ปิดโปรแกรม) ก็ยังต้อนรับได้ */
export function welcomeView(welcome: MemberWelcome, fallbackName = '') {
  const tier = welcome.membership?.tier || null
  const name = String(welcome.displayName || fallbackName || '').trim()
  const points = Math.max(0, Number(welcome.membership?.points) || 0)
  const color = tier && /^#[0-9a-f]{6}$/i.test(String(tier.color || '')) ? String(tier.color) : '#E7C37B'
  return {
    name,
    tierLabel: tier ? `${tier.icon ? `${tier.icon} ` : ''}${tier.name}` : '',
    tierName: tier ? tier.name : '',
    color,
    points,
    pointsLabel: tier ? `${points.toLocaleString('th-TH')} แต้มสะสม` : '',
  }
}
